import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import {Input} from "reactstrap";
import Slider from '@mui/material/Slider';
import FormatPrice from "@utils/formatPrice";
import {rangeLabels, rangeLabelTypes} from "@utils/types/productsFiltersTypes";

import "./style.scss";

const RangeFilter = ({data}) => {
    const {key, label, unit, options} = data;
    const [minValue, setMinValue] = useState();
    const [maxValue, setMaxValue] = useState();
    const [rangeValues, setRangeValues] = useState([]);
    const [urlRangeValues, setUrlRangeValues] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();

    const range_from = searchParams.get(`${key}_${rangeLabels[0]}`);
    const range_to = searchParams.get(`${key}_${rangeLabels[1]}`);

    useEffect(() => {
        let temp = rangeValues;

        if (typeof range_from !== "undefined") {
            temp[0] = range_from;
        }

        if (typeof range_to !== "undefined") {
            temp[1] = range_to;
        }

        setRangeValues([...temp]);
    }, []);

    useEffect(() => {
        if (options) {
            setMinValue(options.min.toString());
            setMaxValue(options.max.toString());

            let temp = rangeValues;

            if (range_from || options.min.toString())
                temp[0] = parseInt(range_from) || parseInt(options.min);

            if (range_to || options.max.toString())
                temp[1] = parseInt(range_to) || parseInt(options.max);

            setRangeValues(temp);
        }
    }, [options]);

    useEffect(() => {
        const fromHasChanged = parseInt(range_from) !== urlRangeValues[0];
        const toHasChanged = parseInt(range_to) !== urlRangeValues[1];

        if (urlRangeValues?.length > 0 && (fromHasChanged || toHasChanged)) {
            const delayDebounceFn = setTimeout(() => {
                addRangeToUrl();
            }, 1500);

            return () => clearTimeout(delayDebounceFn);
        }
    }, [urlRangeValues]);

    const addRangeToUrl = () => {
        let updatedSearchParams = new URLSearchParams(searchParams.toString());

        rangeLabels.forEach(label => {
            updatedSearchParams.set(`${key}_${label}`, rangeValues[rangeLabelTypes[label]]); //range_from, rangeValues[0]
        })

        setSearchParams(updatedSearchParams.toString());
    }

    const handleChangeRange = (event, newValue) => {
        setRangeValues(newValue);
        setUrlRangeValues(newValue);
    };

    const handleRangeInputsChange = (event) => {
        let {name, value} = event.target;
        value = parseInt(value);

        let temp = rangeValues;

        if (value > parseInt(maxValue))
            temp[rangeLabelTypes[name]] = parseInt(maxValue);
        else
            temp[rangeLabelTypes[name]] = value; //name=from , type=0 => temp[0]=value

        if (name === "from" && temp[0] >= temp[1]) {
            temp[0] = temp[1] - 1
        }

        setRangeValues([...temp]);

        setUrlRangeValues([...temp]);
    }

    const slotLength = (minValue + maxValue) / 5;

    const sliderMarks = [
        {
            value: minValue,
            label: <FormattedMessage id="Cheapest"/>,
        },
        {
            value: minValue + slotLength,
            label: "",
        },
        {
            value: minValue + 2 * slotLength,
            label: "",
        },
        {
            value: minValue + 3 * slotLength,
            label: "",
        },
        {
            value: minValue + 4 * slotLength,
            label: "",
        },
        {
            value: minValue + 5 * slotLength,
            label: "",
        },
        {
            value: maxValue,
            label: <FormattedMessage id="MostExpensive"/>,
        },
    ]

    const isRangeZero = Math.max(minValue, maxValue) === 0;

    const sliderStep = Math.pow(10, maxValue?.toString().length - 2);

    if (!rangeValues.length) {
        return null;
    }

    return (
        <section className="range-filter">
            <div className="range-filter-title">
                <h6 className="font-weight-bolder">
                    {label}
                </h6>
            </div>

            <Slider
                getAriaLabel={() => 'range'}
                valueLabelFormat={(value) => FormatPrice(value)}
                step={sliderStep >= 1 ? sliderStep : 1}
                value={rangeValues}
                min={parseInt(minValue)}
                max={parseInt(maxValue)}
                onChange={handleChangeRange}
                valueLabelDisplay="auto"
                marks={isRangeZero ? false : sliderMarks}
            />

            <div className="range-filter-inputs">
                {rangeLabels.map(item =>
                    <div className="range-filter-inputs-min" key={item}>
                        <FormattedMessage id={item}/>
                        <Input
                            type="number"
                            onWheel={(event) => event.target.blur()}
                            value={rangeValues[rangeLabelTypes[item]]}
                            name={item}
                            min={0}
                            onChange={(event) => handleRangeInputsChange(event)}
                        />
                        <small>
                            {unit}
                        </small>
                    </div>
                )}
            </div>
        </section>
    );
}

export default RangeFilter;
